import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OverlayButtonComponent } from '../overlay-button/overlay-button.component';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';

interface SelectFilterItem {
  id: string
  value: string
}

@Component({
  selector: 't-llevo-select-filter',
  standalone: true,
  imports: [
    OverlayButtonComponent,
    MatPseudoCheckboxModule,
    MatButtonModule,
    MatBadgeModule
  ],
  templateUrl: './select-filter.component.html',
  styleUrl: './select-filter.component.css',
})
export class SelectFilterComponent {
  @Input({required: true}) data!: SelectFilterItem[]
  @Input({required: true}) label!: string
  @Input() disableClose = false
  @Input() hideBadge = false
  @Input() disabled = false
  @Input() cancelSelectionText = 'Cancelar selección'

  @Output() valueChange = new EventEmitter<string[]>()

  private _selectedItems: string[] = []

  get selectedItems(){
    return this._selectedItems
  }

  selectItem(itemId: string){
    this._selectedItems.push(itemId)
    this.notifyValueChange()
  }

  deselectItem(itemId: string){
    const itemIndex = this._selectedItems.indexOf(itemId)
    this._selectedItems.splice(itemIndex, 1)
    this.notifyValueChange()
  }

  deselectAll(){
    this._selectedItems = []
    this.notifyValueChange()
  }

  protected isItemSelected(item: string){
    if(this._selectedItems.includes(item)){
      return true
    }
    return false
  }

  protected notifyValueChange(){
    this.valueChange.emit(this._selectedItems)
  }
}
